module.exports = __webpack_public_path__ + "img/showreel1.71a339ca.png";